import React from 'react';
import { SvgIcon } from '@mui/material';
import { shape } from 'prop-types';

const DropletRounded = props => (
  <SvgIcon classes={props.classes} viewBox="0 0 72 91">
    <path d="M38.1 1.87a2.951 2.951 0 00-4.2 0C32.49 3.25.002 35.74.002 55c0 19.86 16.14 36 36 36s36-16.14 36-36c0-19.26-32.49-51.75-33.9-53.13zM30 76c-9.93 0-18-8.07-18-18 0-1.65 1.35-3 3-3s3 1.35 3 3c0 6.63 5.37 12 12 12 1.65 0 3 1.35 3 3s-1.35 3-3 3z" />
  </SvgIcon>
);

DropletRounded.propTypes = {
  classes: shape({}),
};

DropletRounded.defaultProps = {
  classes: {},
};

export default DropletRounded;
